type ToggleOverlayVisibilityProps = {
  shouldShowOverlay: boolean;
  fabricObject: fabric.Object;
  overlayElement: HTMLElement;
  elementDisplayType?: React.CSSProperties['display'];
  toggleProperty?: 'visible' | 'opacity';
};

export const toggleOverlayVisibility = ({
  shouldShowOverlay,
  fabricObject,
  overlayElement,
  elementDisplayType,
}: ToggleOverlayVisibilityProps) => {
  if (shouldShowOverlay) {
    fabricObject.opacity = 0;
    overlayElement.style.display = elementDisplayType || 'block';
  } else {
    overlayElement.style.display = 'none';
    fabricObject.opacity = 1;
  }
};
